"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonStringifyRecursive_1 = __importDefault(require("../shared/jsonStringifyRecursive"));
const valueIsArray_1 = __importDefault(require("../typeAssertions/valueIsArray"));
const valueIsRuntimeFunctionLoggerRecord_1 = __importDefault(require("../typeAssertions/valueIsRuntimeFunctionLoggerRecord"));
const getLoggersFromRef = async (ref) => {
    const rawLoggers = (await ref.once('value')).val();
    if (!(0, valueIsArray_1.default)(rawLoggers)) {
        return [];
    }
    return rawLoggers.filter(valueIsRuntimeFunctionLoggerRecord_1.default);
};
const registerLogger = async ({ loggerId, ref, timestamp, }) => {
    const loggers = await getLoggersFromRef(ref);
    let newLoggers = [
        ...loggers,
        {
            id: loggerId,
            timestamp,
        },
    ];
    if (newLoggers.length > 10) {
        newLoggers = newLoggers.slice(1);
    }
    await ref.set(newLoggers);
};
const createFunctionLogger = async ({ appId, database, functionId, generateId, getTimestamp, }) => {
    const functionLoggersRef = database.ref('functionLogsByApp')
        .child(appId)
        .child(functionId);
    const loggerId = generateId();
    await registerLogger({
        loggerId,
        ref: functionLoggersRef,
        timestamp: getTimestamp(),
    });
    const searchLoggerIndex = async () => {
        const loggers = await getLoggersFromRef(functionLoggersRef);
        const loggerIndex = loggers.findIndex((item) => item.id === loggerId);
        return [loggerIndex, loggers];
    };
    return {
        updateArgs: async (args) => {
            const [loggerIndex, loggers] = await searchLoggerIndex();
            if (loggerIndex < 0) {
                return;
            }
            const newLoggers = [...loggers];
            newLoggers[loggerIndex] = Object.assign(Object.assign({}, newLoggers[loggerIndex]), { args: (0, jsonStringifyRecursive_1.default)(args) });
            await functionLoggersRef.set(newLoggers);
        },
        updateCallback: async (callbackName, callbackArgs) => {
            const [loggerIndex] = await searchLoggerIndex();
            if (loggerIndex < 0) {
                return;
            }
            await functionLoggersRef
                .child(`${loggerIndex}`)
                .child('callbacks')
                .child(callbackName)
                .set({
                args: (0, jsonStringifyRecursive_1.default)(callbackArgs !== null && callbackArgs !== void 0 ? callbackArgs : null),
                timestamp: getTimestamp(),
            });
        },
        updateReturn: async (returnValue) => {
            const [loggerIndex, loggers] = await searchLoggerIndex();
            if (loggerIndex < 0) {
                return;
            }
            const newLoggers = [...loggers];
            newLoggers[loggerIndex] = Object.assign(Object.assign({}, newLoggers[loggerIndex]), { returnValue: (0, jsonStringifyRecursive_1.default)(returnValue) });
            if (newLoggers[loggerIndex].returnValue === undefined) {
                delete newLoggers[loggerIndex].returnValue;
            }
            await functionLoggersRef.set(newLoggers);
        },
    };
};
exports.default = createFunctionLogger;
